export default {
    productSelectValues: [
        'bestallank',
        'brf_report',
        'butiklank',
        'deluxebild',
        'deluxeheader',
        'detail',
        'direktbokning',
        'email-sent',
        'email',
        'facebook',
        'favorit',
        'foretagsgruppering',
        'grabover',
        'grafisk-annons',
        'grunduppgift',
        'hemsidelank',
        'infosida-logo',
        'infosida-delux',
        'infosida',
        'kartuppgift',
        'kopieraadress',
        'kopieraemail',
        'kopieraorg.nummer',
        'kopieratelefonnr',
        'livstilskartan',
        'logo-listning',
        'logo',
        'menylank',
        'offer-button-company',
        'print',
        'result-customers-nearby',
        'route',
        'save',
        'share_email',
        'share_facebook',
        'share_sms',
        'share',
        'show_on_map',
        'sms',
        'soktraff',
        'streetview',
        'suggest',
        'suggest-ad',
        'telefonnr',
        'textlank',
        'topp4-bilder',
        'topp4-logo',
        'vardlank',
        'visatelefonnr',
        '_clicklist',
        '-',
        '',
    ],

    allKnownProducts: [
        '_clicklist',
        '-',
        '',
        'bestallank',
        'brf_report',
        'butiklank',
        'deluxebild',
        'deluxeheader',
        'detail',
        'direktbokning',
        'email-sent',
        'email',
        'facebook',
        'favorit',
        'foretagsgruppering',
        'grafisk-annons',
        'grunduppgift',
        'hemsidelank',
        'infosida-logo',
        'infosida-delux',
        'infosida',
        'kartuppgift',
        'kopieraadress',
        'kopieraemail',
        'kopieraorg.nummer',
        'kopieratelefonnr',
        'livstilskartan',
        'logo-listning',
        'logo',
        'menylank',
        'other',
        'print',
        'result-customers-nearby',
        'route',
        'save',
        'share_email',
        'share_facebook',
        'share_sms',
        'share',
        'show_on_map',
        'sms',
        'soktraff',
        'streetview',
        'suggest',
        'suggest-ad',
        'telefonnr',
        'textlank',
        'topp4-annons',
        'topp4-bilder',
        'topp4-logo',
        'total',
        'vardlank',
        'visatelefonnr',
    ],

    sources: [
        'web',
        'mobile',
        'ios',
        'android',
        'calltracking',
    ],

    pages: [
        'detail',
        'list',
        'map',
        'start',
        'other',
        'favourites',
    ],
};
